import { motion } from "framer-motion";
import { config } from "../config/siteConfig";

const EASE = [0.16, 1, 0.3, 1];

const BookMockup = ({ className = "" }) => (
  <div className={`book-scene ${className}`} data-testid="book-mockup">
    <motion.div
      className="book-float"
      animate={{ y: [0, -14, 0] }}
      transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
    >
      <motion.img
        src={config.book.coverImage}
        alt={`${config.book.title} by ${config.author.name} — book cover`}
        className="book-image"
        draggable={false}
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1.4, ease: EASE }}
      />
    </motion.div>
  </div>
);

export default BookMockup;
